<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Teruggekregen bedragen voor een lijfrente of arbeidsongeschiktheidsverzekering
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Krijg je bedragen terug voor een inkomensvoorziening die je in een eerder jaar hebt afgetrokken? Dan
                moet je deze aftrek herstellen in de aangifte van het jaar waarin je de bedragen terugkrijgt. De
                teruggekregen bedragen worden gezien als 'negatieve uitgaven voor inkomensvoorzieningen'. Je vult ze
                hier in. Over teruggekregen bedragen betaalt je geen revisierente.
                <div class="space10"></div>

                Voor een lijfrente is alleen sprake van teruggekregen bedragen als je de lijfrente binnen 30 dagen na
                het sluiten van de overeenkomst ongedaan hebt gemaakt. Na het verstrijken van die termijn worden de
                teruggekregen bedragen als afkoop van een lijfrente behandeld.

            </div>
        </div>
    </div>

</div>

